import styled from "styled-components";
import {
	TABLET_M_BP,
	MOBILE_L_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const DualCTAWrapper = styled.div`
	padding: 5rem 0;
`;

export const CardWrapper = styled.div`
	background-color: ${(props) => props.bgColor && `${props.bgColor}`};
	display: flex;
	gap: 1rem;
	flex-direction: column;
	padding: 2.5rem ${(props) => (props.hasMedia ? `4.25rem` : `2rem`)};
	border-radius: 1rem;
	height: 100%;
	box-shadow:
		0px 78px 31px rgba(0, 0, 0, 0.01),
		0px 44px 26px rgba(0, 0, 0, 0.02),
		0px 20px 20px rgba(0, 0, 0, 0.03),
		0px 5px 11px rgba(0, 0, 0, 0.04),
		0px 0px 0px rgba(0, 0, 0, 0.04);

	.cta-image {
		border-radius: 0.5rem;
		object-fit: cover;
		width: 100%;
	}
	.card-with-media {
		gap: 1.5rem;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 2.5rem ${(props) => (props.hasMedia ? `3rem` : `3.5rem`)};
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 2.5rem ${(props) => (props.hasMedia ? `2rem` : `1.5rem`)};
		text-align: center;
	}
`;
export const CardContentWrapper = styled.div`
	display: flex;
	gap: 1rem;
	flex-direction: column;
`;
export const ActionWrapper = styled.div`
	.cta-card-action {
		color: ${(props) =>
			props.darkBg
				? `var(--secondary-purple-100)`
				: `var(--secondary-purple-300)`};
	}
`;
